import React, {useEffect, useState} from 'react';
import {ColumnDataType, DataTable, Spinner} from "@tag/tag-components-react-v4";
import {AppGroup} from "../types/AppGroup";
import {ServiceHealthDTO} from "../types/ServiceHealthDTO";
import {CrossFilled, MinusLined, TickFilled} from "@tag/tag-icons";

const ServiceHealth = (props: {selectedAppGroupHealthSummary: {appGrp: AppGroup, serviceHealths: ServiceHealthDTO[]}}) => {
    
    const [loading, setLoading] = useState<boolean>();

    const getColumns = () => {
        return [
            { accessorKey: 'serviceDns', header: 'Service Name', meta: { dataType: 'string' as ColumnDataType } },
            { accessorKey: 'companyName', header: 'Customer', meta: { dataType: 'string' as ColumnDataType } },
            { accessorKey: 'ping', header: 'Ping', cell: (e: any) => renderSuccessOrFailImage(e.row.original.ping) },
            { accessorKey: 'workspaceHealth', header: 'Workspace API', cell: (e: any) => renderSuccessOrFailImage(e.row.original.workspaceHealth) },
            { accessorKey: 'datahubHealth', header: 'Datahub API', cell: (e: any) => renderSuccessOrFailImage(e.row.original.datahubHealth) },
            { accessorKey: 'corporateSiteHealth', header: 'CorporateSite API', cell: (e: any) => renderSuccessOrFailImage(e.row.original.corporateSiteHealth) },
        ];
    }
    
    const getData = () => {
        return props.selectedAppGroupHealthSummary.serviceHealths?.map(s => {
            return {
                serviceDns: s.serviceDns,
                companyName: s.companyName,
                ping: s.servicePing,
                workspaceHealth: s.workspaceApi,
                datahubHealth: s.datahubApi,
                corporateSiteHealth: s.corporateSiteApi,
                shade: getShade(s.companyName, s.servicePing, s.workspaceApi, s.datahubApi, s.corporateSiteApi)
            }
        });
    }
    
    const renderSuccessOrFailImage = (val?: boolean) => {
        if (val === null || val === undefined) {
            return <MinusLined accent={'blue'} />;
        }
        
        if (val)
            return <TickFilled accent={'teal'} />
        else
            return <CrossFilled accent={'purple'} />
    }
    
    const getShade = (company: string, ping?: boolean, workspaceApi?: boolean, datahubApi?: boolean, corpApi?: boolean) => {
        // If unassigned service, white background
        if (!company) {
            return '#FFF';
        }
        
        // If assigned and all success, green background
        if (ping && workspaceApi && datahubApi && corpApi) {
            return '#A7D9B9';
        }
        
        // Otherwise red as somewhere there is an error
        return '#F39F97';
    }

    let content = null;
    if (loading) {
        content = <Spinner />
    }
    else {
        content = (
            <>
                <DataTable
                    scrollerProps={{
                        style:{ width: 'unset' } // Temporary while scroller not needed
                    }}
                    getRowProps={(row) => ({
                        style: {
                            backgroundColor: row.original.shade
                        },
                    })}
                    columns={getColumns()}
                    data={getData()}
                />
            </>
        );
    }

    return (
        <>
            {content}
        </>
    );
}

export default ServiceHealth;
